// extracted by mini-css-extract-plugin
export default {"toggle":"platformToggle_toggle__bWpN1","option":"platformToggle_option__0W-Ke","optionActive":"platformToggle_optionActive__QGWeT","icon":"platformToggle_icon__GY5oi"};